import { render, staticRenderFns } from "./ProcurementDashboard.vue?vue&type=template&id=b80e0dec&"
import script from "./ProcurementDashboard.vue?vue&type=script&lang=js&"
export * from "./ProcurementDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports